module.exports = __webpack_public_path__ + "images/ec9a9b82053adb4e4dfdde683d8bde3ddb67fd8ad6dfdcb3098c9df072ea4b62.svg";